import React, { useState, useMemo } from 'react';

import S from './Lumia.module.css';
import Headline from './Headline';
import LockScreen from './LockScreen';
import Screen from './Screen';
import Footer from './Footer';

const Lumia = (props) => {
  const [state, setState] = useState({
    isLocked: false,
    isOn: true,
    ...props
  });

  const toggleOnOff = useMemo(
    () => () => {
      setState((prevState) => ({
        ...prevState,
        isOn: !prevState.isOn,
        isLocked: prevState.isOn ? true : prevState.isLocked
      }));
    },
    []
  );

  const turnOn = useMemo(
    () => () => {
      setState((prevState) => ({ ...prevState, isOn: true }));
    },
    []
  );

  const handleUnlock = useMemo(
    () => () => {
      setState((prevState) => ({ ...prevState, isLocked: false }));
    },
    []
  );

  // const handleLock = useMemo(
  //   () => () => {
  //     setState((prevState) => ({ ...prevState, isLocked: true }));
  //   },
  //   []
  // );

  const { isLocked, isOn } = state;

  return (
    <div className={S.root}>
      <div className={S.speaker}></div>
      <div className={S.controlButton} data-type="voise-up"></div>
      <div className={S.controlButton} data-type="voise-down"></div>
      <div
        className={S.controlButton}
        data-type="power"
        onClick={toggleOnOff}
      ></div>
      <div className={S.controlButton} data-type="camera"></div>
      <div className={S.display}>
        <div className={S.phoneTitle}>Nokia</div>

        <Screen isOn={isOn} onClick={!isOn ? turnOn : undefined}>
          {isOn && <Headline isLocked={isLocked} />}
          {isOn && (
            <LockScreen
              isLocked={isLocked}
              // isOn={isOn}
              onUnlock={handleUnlock}
            />
          )}
        </Screen>

        <Footer />
      </div>
    </div>
  );
};

export default Lumia;
